import React from 'react';
import { Container, Grid, Typography, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AutomationIcon from '@mui/icons-material/AutoFixHigh';
import DataIcon from '@mui/icons-material/DataUsage';
import ChatIcon from '@mui/icons-material/Chat';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import './AIServices.css';

const services = [
  {
    icon: <SmartToyIcon sx={{ fontSize: 40 }} />,
    title: 'AI Solutions Development',
    description: 'Custom AI solutions designed to solve complex business problems and drive innovation in your organization.'
  },
  {
    icon: <AutomationIcon sx={{ fontSize: 40 }} />,
    title: 'Process Automation',
    description: 'Intelligent automation solutions that streamline workflows and increase operational efficiency.'
  },
  {
    icon: <DataIcon sx={{ fontSize: 40 }} />,
    title: 'Machine Learning',
    description: 'Advanced ML models for predictive analytics, pattern recognition, and data-driven decision making.'
  },
  {
    icon: <ChatIcon sx={{ fontSize: 40 }} />,
    title: 'Conversational AI',
    description: 'Intelligent chatbots and virtual assistants that enhance customer engagement and support.'
  },
  {
    icon: <AnalyticsIcon sx={{ fontSize: 40 }} />,
    title: 'AI Analytics',
    description: 'Deep insights and predictive analytics powered by AI to drive better business decisions.'
  },
  {
    icon: <IntegrationInstructionsIcon sx={{ fontSize: 40 }} />,
    title: 'AI Integration',
    description: 'Seamless integration of AI capabilities into your existing systems and workflows.'
  }
];

const AIServices = () => {
  return (
    <section className="ai-services">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h2" className="ai-section-title" gutterBottom>
            Our AI & Automation Services
          </Typography>
          <Typography variant="subtitle1" className="ai-section-subtitle" gutterBottom>
            Innovative AI solutions for modern businesses
          </Typography>
        </motion.div>

        <Grid container spacing={4} className="services-grid">
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card className="ai-service-card">
                  <CardContent>
                    <div className="ai-service-icon">
                      {service.icon}
                    </div>
                    <Typography variant="h6" className="ai-service-title">
                      {service.title}
                    </Typography>
                    <Typography variant="body2" className="ai-service-description">
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default AIServices; 